import { createTheme } from '@mui/material';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 589,
      md: 1009,
      lg: 1121,
      xl: 1201,
    },
  },
  palette: {
    primary: {
      main: '#7a4dff',
    },
    error: {
      main: '#E4002E',
    },
    info: {
      main: '#717782',
    },
  },
  typography: {
    fontFamily: 'var(--font-family-serif, "Roobert, serif")',
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          letterSpacing: '0.2px',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          fontWeight: '600',
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          letterSpacing: '-0.38px',
          fontWeight: 400,
          color: '#000000',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#a7f5ef',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: 'black',
          svg: {
            width: '28px',
            height: '28px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '11px',
          color: '#717782',
          letterSpacing: '1.18px',
          textTransform: 'uppercase',
          '@media(max-width:768px)': {
            fontSize: '11px',
          },
        },
        shrink: {
          transform: 'translate(0, -1.5px)',
        },
      },
    },
  },
});

export default theme;
